import React from "react";
import { WizClassifySelect, WizAuthority, WizTableForm } from '@/containers/common';
import {component_tool} from '@/tool'
let {WizModal} = component_tool;
import moment from "moment";
import ExamExportDetail from './exportDetail';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
let ref_;
//配置项
const componentName = "examEveryday";

function columns() {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '考试名称',
      name: 'titleSearch',
      searchItem: {}
    },
    {
      title: "考试名称",
      name: "title",
      tableItem: {},
    },
    // {
    //   title: '考试分类',
    //   name: 'categoryIdList',
    //   searchItem: {
    //     type: 'diy',
    //     diy: WizClassifySelect,
    //     returnKey: true,
    //     wizTreeSelectListProps: {
    //       itemProps: {
    //         icon: 'unordered-list',
    //         title: '考试分类',
    //         tips: '请选择考试分类'
    //       },
    //       treeProps: { checkStrictly: true },
    //       checkable: false
    //     },
    //     apiProps: { type: 0 },
    //     selectProps: {
    //       placeholder: '请选择考试分类'
    //     },
    //   }
    // },
    {
      title: "考试分类",
      name: "categoryName",
      searchItem: {
        type: "select"
      },
      dict: [
        {code: '天天学练（专区）', codeName: '天天学练（专区）'},
        {code: '天天学练', codeName: '天天学练'},
      ]
    },
    {
      title: "考试分类",
      name: "categoryInfoName",
      tableItem: {},
    },
    {
      title: '开始时间',
      name: 'examDate',
      dataIndex: "examDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: '开始时间',
      name: 'startDate',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '结束时间',
      name: 'endDate',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: "已考人数",
      name: "alreadyCount",
      tableItem: {},
    }
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export','exportExamScores'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            },
            {
              key: 'exportExamScores',
              custom: true,
              needSelect: true,
              params: { icon: 'export', children: '导出明细', type: 'export'},
              customOnClick:{
                key: 'modal',
                params: {
                  modalParams: {
                    title: '导出明细设置',
                    bordered: true,
                    footer: null,
                    width: 680,
                    destroyOnClose: true,
                    diy: (e) => {
                      let rows = e && e.rows;
                      let examIdList = [];
                      rows.forEach(d => {
                        examIdList.push(d.id)
                      })
                      return <>
                        <ExamExportDetail data={{ examIdList: examIdList }}
                                          changeModal={e.changeModal}
                                          ref={(r) => {
                                            ref_ = r && r.getWrappedInstance();
                                          }}
                        />
                      </>
                    },
                    onOk: () => {
                      ref_._exportExamDetailReport();
                    },
                  },
                },
                formatParams:(rows,record,filters,callback)=>{
                  if (rows && rows.length && rows.length >= 1) {
                    let examIdList = [];
                    rows.forEach(d => {
                      examIdList.push(d.id)
                    })
                    return {examIdList}
                  } else {
                    WizModal.confirm({
                      title: '请至少选择一条数据',
                      onOk: () => {},
                      onCancel() {}
                    })
                  }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = 0;
                if (rows && rows.length && rows.length >= 1) {
                  let categoryId =null;
                  let examIdList = [];
                  rows.forEach(d => {
                    examIdList.push(d.id)
                    if (categoryId===null){
                      categoryId = d.categoryInfoId;
                    }else if (categoryId!=d.categoryInfoId){
                      disabled = 1;
                    }
                  })
                  if (disabled===1){
                    wizNotice.error('请选择相同分类的考试进行明细导出')
                  }
                }else {
                  disabled = 1;
                }
                return {disabled: disabled }
              }
            }
          ],
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.examDate && value.examDate.length === 2) {
              value.startDate = value.examDate[0].format('YYYY-MM-DD HH:mm:ss')
              value.endDate = value.examDate[1].format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看明细" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/examRecordStatistics/examEverydayStatistics/showScore"
              }
            }
          }
        ],
        showAuth: [{
          title: '受众范围',
          text: '查看',
          dataIndex: 'targetScope',
        }]
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/examEverydayPageList`,
    payload: {
      key: `${componentName}@examEverydayPageList`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/examEverydayList`,
    payload: {
      key: `${componentName}@examEverydayList`,
      apiParams: {}
    }
  },
  exportExamEverydayRecordReport: {
    path: `${componentName}/examEverydayRecordReport`,
    payload: {
      key: `${componentName}@examEverydayRecordReport`,
      apiParams: {}
    }
  }
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
